import React from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";

import { ReduxConversation } from "../../store/reducers/convoReducer";
import { actionCreators } from "../../store";
import { formatPhoneNumber } from "../../utils/displayName";
import IosAvatar from "../ios/IosAvatar";

interface ConversationDetailsProps {
  convo: ReduxConversation;
}

const ConversationDetails: React.FC<ConversationDetailsProps> = (
  props: ConversationDetailsProps
) => {
  const title = formatPhoneNumber(props.convo.friendlyName ?? props.convo.sid);
  const dispatch = useDispatch();
  const { updateCurrentConversation } = bindActionCreators(
    actionCreators,
    dispatch
  );

  return (
    <div className="ios-chat-header">
      <div className="ios-chat-header-side">
        <button
          type="button"
          className="ios-back"
          onClick={() => updateCurrentConversation("")}
          aria-label="Back to conversations"
        >
          <span className="ios-back-chevron">‹</span>
        </button>
      </div>
      <div className="ios-chat-title">
        <IosAvatar name={title} size={40} />
        <span className="ios-chat-title-name">{title}</span>
      </div>
      <div className="ios-chat-header-side right" />
    </div>
  );
};

export default ConversationDetails;
